var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExchangeBlueLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_936_2904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6738 10.0464C14.6738 9.41746 14.1621 8.90576 13.5332 8.90576H11.8556V11.187H13.5332C14.1621 11.187 14.6738 10.6753 14.6738 10.0464Z",
    fill: "#5BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8556 13.8821V16.6859H14.1907C14.9637 16.6859 15.5926 16.057 15.5926 15.284C15.5926 14.511 14.9637 13.8821 14.1907 13.8821H11.8556Z",
    fill: "#5BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3565 12.6573C25.3565 11.3762 25.1645 10.1392 24.809 8.97285H31.9547V13.1028L30.294 11.4518L28.3943 13.3627L33.3034 18.2433L38.1871 13.3599L36.2818 11.4545L34.6492 13.0871V6.2783H23.6276C21.4287 2.52578 17.3537 0 12.6992 0C5.71998 0 0.0419312 5.67804 0.0419312 12.6573C0.0419312 19.6365 5.71998 25.3146 12.6992 25.3146C19.6785 25.3146 25.3565 19.6365 25.3565 12.6573ZM7.69104 19.3801V16.6855H9.16109V8.90584H7.69104V6.2113H11.351V4.64918H14.0455V6.2465C15.9188 6.49782 17.3684 8.10547 17.3684 10.0464C17.3684 10.8026 17.1476 11.5079 16.7682 12.1026C17.6941 12.8543 18.2873 14.0007 18.2873 15.2835C18.2873 17.5423 16.4496 19.38 14.1908 19.38H14.0456V20.9421H11.351V19.3801H7.69104Z",
    fill: "#5BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3007 20.6851C26.3214 20.6851 20.6434 26.3631 20.6434 33.3424C20.6434 34.6303 20.8373 35.8736 21.1965 37.0454H14.0452V32.9154L15.7059 34.5664L17.6056 32.6555L12.6964 27.775L7.81268 32.6583L9.718 34.5637L11.3506 32.9312V39.74H22.3833C24.5846 43.4822 28.6539 45.9997 33.3006 45.9997C40.2798 45.9997 45.9579 40.3217 45.9579 33.3424C45.9579 26.3632 40.2799 20.6851 33.3007 20.6851ZM34.8092 39.8316H34.648V41.5706H31.9534V39.8316H28.6496V37.1371H34.8092C35.48 37.1371 36.0258 36.5914 36.0258 35.9206C36.0258 35.2498 35.48 34.7041 34.8092 34.7041H31.6413C29.5397 34.7041 27.8299 32.9943 27.8299 30.8927C27.8299 28.7912 29.5396 27.0813 31.6413 27.0813H31.9534V25.3424H34.648V27.0813H36.924V29.7758H31.6414C31.0256 29.7758 30.5245 30.2769 30.5245 30.8927C30.5245 31.5085 31.0255 32.0095 31.6414 32.0095H34.8093C36.9659 32.0095 38.7204 33.7641 38.7204 35.9206C38.7204 38.0771 36.9658 39.8316 34.8092 39.8316Z",
    fill: "#5BA1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_2904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExchangeBlueLg);
export default __webpack_public_path__ + "static/media/icon-exchange-blue-lg.5c658b95112f05ff13a2807758fe1f3d.svg";
export { ForwardRef as ReactComponent };